import Wrapper from "../../../layout/Wrapper";
import DiscountComponent from "../../../screens/settings/discounts";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "Discount",
	description: "",
};

export default function Discounts() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<DiscountComponent />
		</Wrapper>
	);
}